import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="bg-gray-50 py-12 px-4 md:px-10 lg:px-20">
      <div className="max-w-5xl mx-auto bg-white p-8 rounded-2xl shadow-lg border border-gray-200">

        <h1 className="text-3xl font-bold mb-4 text-gray-900">
          Terms and Conditions
        </h1>

        <p className="text-gray-500 mb-6">
          Last updated: March 17, 2026
        </p>

        <p className="text-gray-700 mb-6">
          Please read these terms and conditions carefully before using Our Service.
        </p>

        {/* Interpretation */}
        <h2 className="text-2xl font-semibold mt-8 mb-3 text-gray-900">
          Interpretation and Definitions
        </h2>

        <h3 className="text-xl font-semibold mt-4 mb-2 text-gray-800">
          Interpretation
        </h3>
        <p className="text-gray-700 mb-4">
          The words whose initial letters are capitalized have meanings defined under the following conditions.
        </p>

        <h3 className="text-xl font-semibold mt-4 mb-2 text-gray-800">
          Definitions
        </h3>

        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li><strong>Affiliate:</strong> Entity under common control.</li>
          <li><strong>Country:</strong> Telangana, India.</li>
          <li><strong>Company:</strong> Abhishek M Financial Services Pvt Ltd.</li>
          <li><strong>Device:</strong> Any device accessing the service.</li>
          <li><strong>Service:</strong> The Website.</li>
          <li><strong>Terms:</strong> These Terms and Conditions.</li>
          <li><strong>Third-Party Social Media Service:</strong> External services linked.</li>
          <li><strong>Website:</strong> Abhishek M Financial Services.</li>
          <li><strong>You:</strong> User accessing the service.</li>
        </ul>

        {/* Acknowledgment */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Acknowledgment
        </h2>

        <p className="text-gray-700 mb-4">
          These Terms govern your use of our Service and form the agreement between You and the Company.
        </p>

        <p className="text-gray-700 mb-4">
          By accessing or using the Service, You agree to be bound by these Terms.
        </p>

        <p className="text-gray-700 mb-4">
          You must be at least 18 years old to use this Service.
        </p>

        {/* Links */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Links to Other Websites
        </h2>

        <p className="text-gray-700 mb-4">
          Our Service may contain links to third-party websites. We are not responsible for their content or policies.
        </p>

        {/* Termination */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Termination
        </h2>

        <p className="text-gray-700 mb-4">
          We may terminate your access immediately if you breach these Terms.
        </p>

        {/* Liability */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Limitation of Liability
        </h2>

        <p className="text-gray-700 mb-4">
          Our liability is limited to the amount paid by You or 100 USD if nothing was paid.
        </p>

        {/* Disclaimer */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Disclaimer
        </h2>

        <p className="text-gray-700 mb-4">
          The Service is provided "AS IS" without warranties of any kind.
        </p>

        {/* Law */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Governing Law
        </h2>

        <p className="text-gray-700 mb-4">
          These Terms are governed by the laws of Telangana, India.
        </p>

        {/* Changes */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Changes to Terms
        </h2>

        <p className="text-gray-700 mb-4">
          We may update these Terms at any time. Continued use means acceptance.
        </p>

        {/* Contact */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Contact Us
        </h2>

        <ul className="space-y-2 text-gray-700">
          <li>Email: sunoji@abhifs.com</li>
          <li>
            Website:{" "}
            <a href="/contact" className="text-green-600 hover:underline">
              Contact Page
            </a>
          </li>
          <li>Phone: +91 93463 99632</li>
        </ul>

      </div>
    </div>
  );
}